import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainNavigationComponent } from './components/main-navigation/main-navigation.component';
import { PortalPage } from './pages/portal/portal.page';
import { routing } from './portal.routing';
import { HomePage } from './pages/home/home.page';
import { FooterComponent } from './components/footer/footer.component';
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule, MatChipsModule,
  MatDialogModule,
  MatFormFieldModule, MatIconModule,
  MatInputModule,
  MatPaginatorModule
} from '@angular/material';
import { AboutUsPage } from './pages/about-us/about-us.page';
import { ContactPage } from './pages/contact/contact.page';
import { LoginPage } from './pages/login/login.page';
import { NewsPage } from './pages/news/news.page';
import { ContactInformationComponent } from './components/contact-information/contact-information.component';
import { SharedModule } from '../../shared/shared.module';
import { PortalService } from './services/portal.service';
import { ReferralSearchComponent } from './components/referral-search/referral-search.component';
import { ReferralInfoDialogComponent } from './components/referral-info-dialog/referral-info-dialog.component';
import { ContactInfoBannerComponent } from './components/contact-info-banner/contact-info-banner.component';
import { LogoBannerComponent } from './components/logo-banner/logo-banner.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { ReactiveFormsModule } from '@angular/forms';

const modules = [
  routing,
  CommonModule,
  MatInputModule,
  MatFormFieldModule,
  MatButtonModule,
  MatCheckboxModule,
  SharedModule,
  MatPaginatorModule,
  MatDialogModule,
  MatCardModule,
  RecaptchaModule,
  RecaptchaFormsModule,
  MatAutocompleteModule,
  ReactiveFormsModule,
  MatChipsModule,
  MatIconModule
];

const components = [
  MainNavigationComponent,
  FooterComponent,
  ContactInformationComponent,
  ReferralSearchComponent,
  ReferralInfoDialogComponent,
  ContactInfoBannerComponent,
  LogoBannerComponent
];

const pages = [
  PortalPage,
  HomePage,
  AboutUsPage,
  ContactPage,
  LoginPage,
  NewsPage
];

const services = [
  PortalService
];

const entryComponents = [
  ReferralInfoDialogComponent
];

@NgModule({
  declarations: [...components, ...pages],
  providers: [...services],
  entryComponents: [...entryComponents],
  imports: [...modules]
})
export class PortalModule { }
